export default "/images/sis_logo.svg"